export default {
  AUDIO_SETTINGS: 'audioSettings',
  BACKGROUND_EFFECTS: 'backgroundEffects',
  BROADCAST_COMPLETE: 'broadcastComplete',
  CHANGE_DEVICE: 'changeDevice',
  CREATE_BROADCAST: 'createBroadcast',
  CREATE_RECORDING: 'createRecording',
  DELETE_ASSET: 'deleteAsset',
  DELETE_BROADCAST: 'deleteBroadcast',
  END_BROADCAST: 'endBroadcast',
  ENTER_BROADCAST_REJECT: 'enterBroadcastReject',
  ISO_RECORD_REJECT: 'isoRecordReject',
  LEAVE_BROADCAST: 'leaveBroadcast',
  MANAGE_RECORDINGS: 'manageRecordings',
  MEDIA_UPLOAD: 'mediaUpload',
  PENDING_RECORDINGS: 'pendingRecordings',
  ROLES_LICENSING: 'rolesLicensing',
  SCREEN_SHARE_PERMISSION: 'screenSharePermission',
  SLIDE_SHARE: 'slideShare',
  STOP_SCREEN_SHARE: 'stopScreenShare',
  VIDEO_SETTINGS: 'videoSettings',
};
